/*
 *******************************************************************************
 *
 *  Filename:   @/pages/renderers/FormattedDate.js
 *
 *  Syntax:     renderCell: (params) => <FormattedDate value={params.value} />
 *
 *  Synopsis:   Use this component to display dates in a more readable
 *              format within table columns.
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Wednesday, April 12, 2023 - 2:21 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from "react";

const FormattedDate = (props) => {
  const date = new Date(props.value);
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);

  return <span>{formattedDate}</span>;
};

export default FormattedDate;
